<p class="italic">
  Dedicated to Pandelune, the author of <a href="orthogone/">Orthogone</a>,
  <a href="murano-fantasy/">Murano Fantasy</a>
  and <a href="reverie/">Reverie</a>.
  <br />
  Also a few
  <a href="genuary/">Genuary 2023</a> experiments, and a WIP: <a href="dashboard-dyslexia/">Dashboard Dyslexia</a>.
</p>
